<template>
  <v-dialog
    :value="showDialog"
    max-width="675px"
    tile
    @click:outside="closeDialog"
  >
    <v-app-bar
      class="primary"
      height="45"
    >
      <div class="d-flex align-center justify-space-between">
        <p class="white--text text-body-1 text-uppercase mb-0">
          {{ titleDialog || '' }}
        </p>
        <v-btn
          icon
          class="white--text"
          :ripple="false"
          small
          rounded
          style="right: 12px"
          @click="closeDialog"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </v-app-bar>
    <v-card style="border-radius: 0">
      <v-carousel
        v-if="images"
        hide-delimiters
        :height="'500px'"
        :value="carouselValue"
        class="informDialog__carousel"
        @change="onCarouselChange"
      >
        <v-carousel-item
          v-for="(src, n) in renderedImageDetails"
          :key="n"
          :src="src"
          :position="'center'"
          contain
          @click="zoomImage(src)"
        />
      </v-carousel>

      <div
        v-if="subCarouselLength"
        class="d-flex align-center justify-start py-3"
        style="overflow: auto"
      >
        <div
          v-for="(src, n) in renderedImageDetails"
          :key="n"
          class="px-1"
        >
          <v-card
            tile
            flat
            :elevation="n === carouselValue ? 3 : 0"
            @click="onCarouselChange(n)"
          >
            <v-img
              :src="src"
              contain
              height="70px"
              width="70px"
            >
              <template #placeholder>
                <v-row
                  style="background-color: #ddd"
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  />
                </v-row>
              </template>
            </v-img>
          </v-card>
        </div>
      </div>
      <div
        v-if="!$wait.is('loadingFabricDetails')"
        class="pa-8"
      >
        <h2
          v-if="fabricDetails.name"
          class="pb-9 text-h3 text-uppercase"
        >
          <span v-if="fabricPicker"> {{fabricDetails.name}}</span>
          <span v-else> {{ fabricDetails.name }}</span>
        </h2>

        <table
          v-if="fabric"
          class="informDialog__table"
        >
          <tr>
            <td>{{ fabricTransparency }}</td>
            <td>{{ fabricType }}</td>
          </tr>
          <tr>
            <td>{{ widthType }}</td>
            <td>{{ fabricDetails.width }} cm</td>
          </tr>
          <!--          <tr>-->
          <!--            <td>Materiaal</td>-->
          <!--            <td>-->
          <!--              <p-->
          <!--                v-if="fabricDetails.ac"-->
          <!--                class="ma-0"-->
          <!--              >-->
          <!--                {{ fabricDetails.ac }}% acetaat-->
          <!--              </p>-->
          <!--              <p-->
          <!--                v-if="fabricDetails.co"-->
          <!--                class="ma-0"-->
          <!--              >-->
          <!--                {{ fabricDetails.co }}% katoen-->
          <!--              </p>-->
          <!--              <p-->
          <!--                v-if="fabricDetails.div"-->
          <!--                class="ma-0"-->
          <!--              >-->
          <!--                {{ fabricDetails.div }}% overig-->
          <!--              </p>-->
          <!--              <p-->
          <!--                v-if="fabricDetails.li"-->
          <!--                class="ma-0"-->
          <!--              >-->
          <!--                {{ fabricDetails.li }}% linnen-->
          <!--              </p>-->
          <!--              <p-->
          <!--                v-if="fabricDetails.lrx"-->
          <!--                class="ma-0"-->
          <!--              >-->
          <!--                {{ fabricDetails.lrx }}% lurex-->
          <!--              </p>-->
          <!--              <p-->
          <!--                v-if="fabricDetails.ma"-->
          <!--                class="ma-0"-->
          <!--              >-->
          <!--                {{ fabricDetails.ma }}% modacryl-->
          <!--              </p>-->
          <!--              <p-->
          <!--                v-if="fabricDetails.pa"-->
          <!--                class="ma-0"-->
          <!--              >-->
          <!--                {{ fabricDetails.pa }}% polyester / nylon-->
          <!--              </p>-->
          <!--              <p-->
          <!--                v-if="fabricDetails.pe"-->
          <!--                class="ma-0"-->
          <!--              >-->
          <!--                {{ fabricDetails.pe }}% polyester-->
          <!--              </p>-->
          <!--              <p-->
          <!--                v-if="fabricDetails.trcs"-->
          <!--                class="ma-0"-->
          <!--              >-->
          <!--                {{ fabricDetails.trcs }}% trevira CS-->
          <!--              </p>-->
          <!--              <p-->
          <!--                v-if="fabricDetails.se"-->
          <!--                class="ma-0"-->
          <!--              >-->
          <!--                {{ fabricDetails.ac }}% zijde-->
          <!--              </p>-->
          <!--              <p-->
          <!--                v-if="fabricDetails.vi"-->
          <!--                class="ma-0"-->
          <!--              >-->
          <!--                {{ fabricDetails.vi }}% viscose-->
          <!--              </p>-->
          <!--              <p-->
          <!--                v-if="fabricDetails.wol"-->
          <!--                class="ma-0"-->
          <!--              >-->
          <!--                {{ fabricDetails.wol }}% wol-->
          <!--              </p>-->
          <!--            </td>-->
          <!--          </tr>-->
          <tr>
            <td>Material</td>
            <td>{{ fabricDetails.pe }}% Polyester</td>
          </tr>
        </table>
        <p
          v-if="fabricDetails.plugin_fabric_memo"
          class="pb-2 mt-7"
        >
          {{ fabricDetails.plugin_fabric_memo }}
        </p>
        <p
          v-else
          class="text-body-1 pt-5"
        >
          {{ fabricDetails.description}}
        </p>
        <v-container
          v-if="fabric"
          class="pa-1 pb-5"
        >
          <v-row class="washing-symbols ma-n1">
            <v-col
              v-if="fabricDetails.wash_property"
              class="pa-1"
            >
              <washing-symbol
                :property="fabricDetails.wash_property"
                :with-border="true"
              />
            </v-col>
            <v-col
              v-if="fabricDetails.iron_property"
              class="pa-1"
            >
              <washing-symbol
                :property="fabricDetails.iron_property"
                :with-border="true"
              />
            </v-col>
            <v-col
              v-if="fabricDetails.bleach_property"
              class="pa-1"
            >
              <washing-symbol
                :property="fabricDetails.bleach_property"
                :with-border="true"
              />
            </v-col>
            <v-col
              v-if="fabricDetails.dry_property"
              class="pa-1"
            >
              <washing-symbol
                :property="fabricDetails.dry_property"
                :with-border="true"
              />
            </v-col>
            <v-col
              v-if="fabricDetails.clear_property"
              class="pa-1"
            >
              <washing-symbol
                :property="fabricDetails.clear_property"
                :with-border="true"
              />
            </v-col>
            <v-spacer />
          </v-row>
        </v-container>
        <div
          v-if="fabricDetails.price"
          class="pb-10"
        >
          <p class="text-body-1 mb-2">
            Fabric price per meter
          </p>
          <p class="text-h2 primary--text font-weight-bold">
            $ {{ fabricDetails.price }}
          </p>
        </div>

        <v-btn
          v-if="dialogAction"
          dark
          tile
          class="text-body-1"
          @click="pickFabric($event, fabricDetails.fabric_uuid)"
        >
          Choose this fabric
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { _ } from 'vue-underscore'
import { splitFloat } from 'vue-flow-generator/src/utils'

import { requireAssetWithFallback } from '@/utils'

import WashingSymbol from '../Symbols/WashingSymbol'

export default {
  name: 'FabricInfoDialog',
  components: { WashingSymbol },
  props: {
    showDialog: Boolean,
    titleDialog: {
      type: String,
      default: '',
      description: 'Dialog title'
    },
    fabricPicker: {
      type: Boolean,
      default: false,
    },
    curtainPicker: {
      type: Boolean,
      default: false,
    },
    fabricDetails: {
      type: Object,
      default: () => ({})
    },
    dialogAction: {
      type: Boolean,
      default: false,
      description: 'Responsible for displaying the button'
    },
    fabric: {
      type: Boolean,
      default: false,
      description: 'Display some description only from fabric component'
    }
  },
  data() {
    return {
      selectedImage: null,
      carouselValue: '0'
    }
  },

  computed: {
    renderedImageDetails() {
      return this.fabricDetails.rendered_image_details
    },
    fabricType() {
      if (this.fabricDetails.type) {
        return this.$t(`fabricType.${this.fabricDetails.type}`)
      }
      return ''
    },
    formattedPrice() {
      return splitFloat(this.fabricDetails.price)
    },
    images() {
      return this.fabricDetails.rendered_image_details
    },
    widthType() {
      if (this.fabricDetails.width_type) {
        return this.$t(`widthType.${this.fabricDetails.width_type}`)
      }
      return ''
    },
    tags() {
      return (this.fabricDetails.tags || []).map((tag) => tag.id)
    },
    fabricTransparency() {
      const tagsMapping = [
        {
          id: [14, 15],
          name: this.$t('fabricTransparency.transparent')
        },
        {
          id: [16],
          name: this.$t('fabricTransparency.translucent')
        },
        {
          id: [17, 18],
          name: this.$t('fabricTransparency.darkening')
        }
      ]

      for (const tagMapping of tagsMapping) {
        if (_.union(this.tags, tagMapping.ids)) {
          return tagMapping.name
        }
      }
      return ''
    },
    subCarouselLength() {
      return (
        this.fabricDetails.rendered_image_details &&
        this.fabricDetails.rendered_image_details.length > 1
      )
    }
  },
  watch: {
    showDialog: function () {
      this.carouselValue = '0'
    },
  },
  methods: {
    addColorWord(words) {
      const wordsArr = words.split(' ')
      return `${wordsArr[0]} ${wordsArr[1]}`
    },
    closeDialog() {
      this.$emit('closeDialog')
    },
    pickFabric(event, fabricDetails) {
      this.$emit('pickFabric', fabricDetails)
    },
    onCarouselChange(number) {
      this.carouselValue = number
    },
    zoomImage(src) {
      // TODO make zoom component
      this.selectedImage = src
    }
  }
}
</script>

<style scoped lang="scss">
td {
  vertical-align: baseline;
}

.row.washing-symbols .col {
  flex-grow: 0;
}

p.price sup {
  font-size: 15px;
  line-height: 1em;
  margin-left: 3px;
}

.v-toolbar__content {
  .v-btn {
    position: absolute;
    right: 0;
  }
}
</style>

<style lang="scss">
@import './src/styles/variables';

.informDialog {
  &__carousel {
    .v-btn {
      background-color: $primary-color;

      .v-icon {
        font-size: 20px !important;
      }
    }
  }

  &__table {
    td {
      font-size: 1rem;
      font-family: 'Montserrat', sans-serif;
      font-weight: 400;
      line-height: 25px;
    }
  }
}
</style>
